import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import wb from "./registerServiceWorker";
import vSelect from "vue-select";
import VueSweetalert2 from "vue-sweetalert2";
import VueGoodTablePlugin from "vue-good-table";
import VueApexCharts from "vue-apexcharts";

import "vue-select/dist/vue-select.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-good-table/dist/vue-good-table.css";
// dashkit themes
import "./assets/css/libs.bundle.css";
import "./assets/css/theme.bundle.css";
import "leaflet/dist/leaflet.css";

import VeeValidate from "vee-validate";
import VCalendar from "v-calendar";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LCircle,
  LTooltip,
  LPopup,
} from "vue2-leaflet";

// vuelayers
import VueLayers from "vuelayers";
import "vuelayers/dist/vuelayers.css";

window.queryString = require("query-string");

Vue.use(VueSweetalert2);
Vue.use(VueGoodTablePlugin);
Vue.use(VueApexCharts);
Vue.use(VeeValidate);
Vue.use(VueLayers);
Vue.use(VCalendar, {
  componentPrefix: "v",
});

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-polygon", LPolygon);
Vue.component("l-circle", LCircle);
Vue.component("l-tooltip", LTooltip);
Vue.component("l-popup", LPopup);

Vue.component("v-select", vSelect);
Vue.component("v-checkbox", vSelect);
Vue.component("apexchart", VueApexCharts);

Vue.prototype.$workbox = wb;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
